import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { FiHome, FiLogOut } from "react-icons/fi"; // Import icons
import "./UserHeader.css";

const UserHeader = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("authToken"); // Clear authentication token
    localStorage.removeItem("userRole"); // Clear authentication token
    navigate("/login"); // Redirect to login page
  };

  return (
    <header className="user-header">
      {/* Left Section: Home Link with Icon */}
      <div className="header-left">
        <Link
          to="/"
          target="_blank"
          rel="noopener noreferrer"
          className="home-link"
        >
          <FiHome className="home-icon" /> Página Principal
        </Link>
      </div>

      {/* Right Section: Log Off Button */}
      <div className="header-right">
        <button className="logout-button" onClick={handleLogout}>
          <FiLogOut className="logout-icon" /> Terminar Sessão
        </button>
      </div>
    </header>
  );
};

export default UserHeader;
